import { RequestOptions } from "./requestOptions";

export default class RequestInterceptor {
  constructor(request: (url: URL, options: RequestOptions) => { url: URL; options: RequestOptions }) {
    this.request = request;
  }

  request: (url: URL, options: RequestOptions) => { url: URL; options: RequestOptions };
}
